export const DocumentTypeTableTitle = [
    { label: 'ລຳດັບ' },
    { label: 'ອັງກິດ' },
    { label: 'ລາວ' },
    { label: 'ໝວດໝູ່' },
    { label: 'ລະຫັດສີ' },
    { label: 'ເນື້ອໃນ' },
    { label: 'ການຈັດການ' },
];